export function getUrl(id, startParams) {
  let url =  new URL(`microflow/${id}`, window.appConfig.GraphQlUrl)
  if (startParams?.EventName && startParams?.PageId) {
    
    url.searchParams.append('pageId', startParams.PageId)
    url.searchParams.append('eventName', startParams.EventName)
   
  }
  return url
}


export class MicroflowApi {

  constructor({ axios }) {
    this.axios = axios
  }
  async callMicroFlow(id, startParams, properties) {
    let response = await this.axios.post(getUrl(id, startParams), properties)
    return response
  }
}